/**
 * @generated SignedSource<<f7c0b5efa93ad6897595dcc478304ca4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RearrangePagesInput = {
  clientMutationId?: string | null;
  messageDefinitionId: string;
  pageIds: ReadonlyArray<string>;
};
export type useMessagePageMutations_RearrangePagesMutation$variables = {
  input: RearrangePagesInput;
};
export type useMessagePageMutations_RearrangePagesMutation$data = {
  readonly Admin: {
    readonly MessageDefinitions: {
      readonly rearrangePages: {
        readonly messageDefinition: {
          readonly id: string;
        };
      } | null;
    };
  };
};
export type useMessagePageMutations_RearrangePagesMutation = {
  response: useMessagePageMutations_RearrangePagesMutation$data;
  variables: useMessagePageMutations_RearrangePagesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageDefinitionsAdminMutationSchema",
        "kind": "LinkedField",
        "name": "MessageDefinitions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "RearrangePagesPayload",
            "kind": "LinkedField",
            "name": "rearrangePages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageDefinition",
                "kind": "LinkedField",
                "name": "messageDefinition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMessagePageMutations_RearrangePagesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMessagePageMutations_RearrangePagesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8a5ac62a32f04ee7b6d19744773a532b",
    "id": null,
    "metadata": {},
    "name": "useMessagePageMutations_RearrangePagesMutation",
    "operationKind": "mutation",
    "text": "mutation useMessagePageMutations_RearrangePagesMutation(\n  $input: RearrangePagesInput!\n) {\n  Admin {\n    MessageDefinitions {\n      rearrangePages(input: $input) {\n        messageDefinition {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a76ae0e431d0ca1399283a587bc25389";

export default node;
